import { render, staticRenderFns } from "./CollaboratorsView.vue?vue&type=template&id=48a4b2df&"
import script from "./CollaboratorsView.vue?vue&type=script&lang=js&"
export * from "./CollaboratorsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports